import React from 'react';
import { Typography } from 'antd';
import './closingPackageWorkspace.css';

const { Text } = Typography;

export type ClosingPackageSectionPlaceholderProps = {
  title: string;
  stage: string;
  description?: string;
  className?: string;
};

/**
 * Temporary slot for FE-003+ sections. No business logic.
 */
const ClosingPackageSectionPlaceholder: React.FC<ClosingPackageSectionPlaceholderProps> = ({
  title,
  stage,
  description,
  className,
}) => (
  <div
    className={['cp-section-placeholder', className].filter(Boolean).join(' ')}
    data-stage={stage}
  >
    <div className="cp-section-placeholder__title">{title}</div>
    <Text type="secondary" className="cp-section-placeholder__stage">
      {stage}
    </Text>
    {description ? (
      <Text type="secondary" className="cp-section-placeholder__desc">
        {description}
      </Text>
    ) : null}
  </div>
);

export default ClosingPackageSectionPlaceholder;
